(function () {
  // This file is requested by whichever surface renders the buy box (the
  // product section, the collection grid's quick-view popups). Bail out on a
  // second execution so a page pulling it in twice can't end up with two sets
  // of document-level listeners repainting every gift box twice per click.
  if (window.buyBoxGiftListLoaded) return;
  window.buyBoxGiftListLoaded = true;

  var SCOPE_SELECTOR = '.product__info-container';

  // <main-product-form> is the tightest wrapper that holds a single buy box's
  // purchase-option radios, hidden variant radios AND its gift box, so it's the
  // correct scope everywhere. It matters on the collection page, where every
  // product card carries its own quick-view popup: falling through to
  // `document` there would repaint one product's gift box from a DIFFERENT
  // product's selected variant. .product__info-container stays as a fallback
  // for the product page, and `document` only for markup with neither.
  function getScope(el) {
    return el.closest('main-product-form') || el.closest(SCOPE_SELECTOR) || document;
  }

  function isSubscriptionSelected(scope) {
    var checked = scope.querySelector('.rc-radio__input:checked');
    return !!checked && checked.value === 'subscription';
  }

  function formatMoney(cents) {
    var symbol = document.body.getAttribute('data-currency') || '';
    return Shopify.formatMoney(cents, symbol + '{{amount}}');
  }

  function getVariantProductsMap(giftBox) {
    var mapEl = giftBox.querySelector('.gift-box__variant-products-map');
    if (!mapEl) return {};
    try {
      return JSON.parse(mapEl.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function fillDummySlot(item) {
    item.classList.add('is-dummy');
    item.removeAttribute('data-gift-product-id');
    item.removeAttribute('data-variant-id');

    var titleEl = item.querySelector('.gift-box__title');
    if (titleEl) titleEl.textContent = 'Free Gift';

    var imageEl = item.querySelector('.gift-box__image:not(.gift-box__image--dummy)');
    if (imageEl) imageEl.style.display = 'none';

    var priceBadge = item.querySelector('.gift-box__price-badge');
    if (priceBadge) priceBadge.style.display = 'none';
  }

  function fillRealSlot(item, product) {
    item.classList.remove('is-dummy');
    item.setAttribute('data-gift-product-id', product.productId);
    item.setAttribute('data-variant-id', product.variantId);

    var titleEl = item.querySelector('.gift-box__title');
    if (titleEl) titleEl.textContent = product.title;

    var imageEl = item.querySelector('.gift-box__image:not(.gift-box__image--dummy)');
    if (imageEl) {
      if (product.image) {
        imageEl.src = product.image;
        imageEl.alt = product.alt || '';
        imageEl.style.display = '';
      } else {
        imageEl.style.display = 'none';
      }
    }

    var priceBadge = item.querySelector('.gift-box__price-badge');
    if (priceBadge) {
      if (product.worth > 0) {
        var valueEl = priceBadge.querySelector('.gift-box__price-badge-value');
        if (valueEl) valueEl.textContent = formatMoney(product.worth);
        priceBadge.style.display = '';
      } else {
        priceBadge.style.display = 'none';
      }
    }
  }

  // Every gift-box grid slot always stays on screen (same slot count at all
  // times, matching the design) — only its CONTENT changes. A slot is filled
  // with a real product ONLY from the CURRENTLY SELECTED variant's own
  // gift_products list, in that variant's own order; a slot beyond that
  // variant's own list length shows a generic "Free Gift" placeholder,
  // never another variant's real product carried over.
  function renderGiftBoxSlots(giftBox) {
    var scope = getScope(giftBox);
    var unlockAllOnetime = giftBox.getAttribute('data-unlock-all-onetime') === 'true';
    var subscribing = isSubscriptionSelected(scope);

    var checkedVariant = scope.querySelector('.variant-item:checked');
    var variantId = checkedVariant ? checkedVariant.value : null;
    var map = getVariantProductsMap(giftBox);
    var products = (variantId && map[variantId]) || [];

    var lockOwnedSlots = !subscribing && !unlockAllOnetime;

    giftBox.querySelectorAll('.gift-box__item').forEach(function (item) {
      var slotIndex = parseInt(item.getAttribute('data-gift-slot'), 10) - 1;
      var product = products[slotIndex];

      if (product) {
        fillRealSlot(item, product);
        var unlocked = !lockOwnedSlots;
        item.classList.toggle('is-unlocked', unlocked);
        item.classList.toggle('is-locked', !unlocked);
      } else {
        fillDummySlot(item);
        item.classList.remove('is-unlocked');
        item.classList.add('is-locked');
      }
    });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.classList) return;
    var isVariantChange = event.target.classList.contains('variant-item');
    var isPurchaseOptionChange = event.target.classList.contains('rc-radio__input');
    if (!isVariantChange && !isPurchaseOptionChange) return;

    var scope = getScope(event.target);
    scope.querySelectorAll('.gift-box').forEach(renderGiftBoxSlots);
  });

  function initGiftBoxes(root) {
    (root || document).querySelectorAll('.gift-box').forEach(renderGiftBoxSlots);
  }

  // Exposed so markup that appears after page load can be brought up to the
  // same state — the collection grid replaces its whole product list (and with
  // it every card's quick-view gift box) whenever a filter is applied.
  window.initBuyBoxGiftBoxes = initGiftBoxes;

  document.addEventListener('DOMContentLoaded', function () {
    initGiftBoxes(document);
  });
})();
